import { STANDBY_BOLT_ICON_SVG_SOURCE } from "@/app/game/standbyBoltIcon";
import type { Disposable } from "@/shared/contracts/lifecycle";

export interface StandbyView extends Disposable {
  readonly root: HTMLButtonElement;
  hide(): void;
  show(): void;
}

interface CreateStandbyViewOptions {
  readonly label: string;
  readonly resumeAriaLabel: string;
  readonly onResume: () => void;
}

export function createStandbyView(
  options: CreateStandbyViewOptions,
): StandbyView {
  const root = document.createElement("button");
  root.type = "button";
  root.className = "hover-idle-standby-screen";
  root.dataset.standbyScreen = "true";
  root.hidden = true;
  root.setAttribute("aria-label", options.resumeAriaLabel);

  const content = document.createElement("span");
  content.className = "hover-idle-standby-content";
  content.setAttribute("aria-hidden", "true");

  const icon = document.createElement("span");
  icon.className = "hover-idle-standby-icon";
  icon.innerHTML = STANDBY_BOLT_ICON_SVG_SOURCE;

  const title = document.createElement("strong");
  title.className = "hover-idle-standby-title";
  title.textContent = options.label;

  content.append(icon, title);
  root.append(content);
  root.addEventListener("click", options.onResume);

  return {
    root,
    hide(): void {
      root.hidden = true;
    },
    show(): void {
      root.hidden = false;
      root.focus({ preventScroll: true });
    },
    dispose(): void {
      root.removeEventListener("click", options.onResume);
      root.remove();
    },
  };
}
